// MUI COMPONENTS

// CUSTOM INPUTS
import { useTranslation } from "react-i18next";
import Input from "./inputs/input";
import InputCountrySelect from "./inputs/input-country-select";
import InputAutocomplete from "./inputs/input_autocomplete";
import InputCheckbox from "./inputs/input_checkbox";
import InputRadio from "./inputs/input_radio";
import InputSelect from "./inputs/input_select";

export default function FormField({
	id = null,
	label,
	type,
	name,
	size,
	sx,
	placeholder = "",
	full_width,
	helper,
	rows,
	only_positive,
	always_checked = false,
	auto_complete,
	password = false,
	auto_focus = false,
	disabled = false,
	on_change = null,
	options = [],
	start_adornment = null,
	end_adornment = null,
	required = false,
	show_error_on_exit = false,
}) {
	const { t } = useTranslation();

	const labelT = t(label);

	const determInput = () => {
		switch (type) {
			case "text_area":
				return (
					<Input
						id={id}
						auto_focus={auto_focus}
						disabled={disabled}
						name={name}
						multi_line
						rows={rows}
						label={labelT}
						size={size}
						sx={sx}
						placeholder={placeholder}
						auto_complete={auto_complete}
						full_width={full_width}
						start_adornment={start_adornment}
						end_adornment={end_adornment}
						on_change={on_change}
						helper={helper}
						required={required}
						show_error_on_exit={show_error_on_exit}
					/>
				);

			case "autocomplete":
				return (
					<InputAutocomplete
						id={id}
						name={name}
						label={label}
						options={options}
						disabled={disabled}
						size={size}
					/>
				);
			case "country_select":
				return (
					<InputCountrySelect
						auto_focus={auto_focus}
						disabled={disabled}
						name={name}
						label={label}
						full_width={full_width}
						size={size}
						sx={sx}
					/>
				);
			case "select":
				return (
					<InputSelect
						auto_focus={auto_focus}
						select_list={options}
						disabled={disabled}
						name={name}
						label={label}
						full_width={full_width}
						size={size}
						sx={sx}
					/>
				);

			case "checkbox":
				return (
					<InputCheckbox
						on_change={on_change}
						name={name}
						label={label}
						disabled={disabled}
						always_checked={always_checked}
					/>
				);

			case "number":
				return (
					<Input
						id={id}
						placeholder={placeholder}
						auto_focus={auto_focus}
						disabled={disabled}
						name={name}
						label={labelT}
						size={size}
						type="number"
						sx={sx}
						on_change={on_change}
						full_width={full_width}
						start_adornment={start_adornment}
						end_adornment={end_adornment}
						helper={helper}
						auto_complete={auto_complete}
						only_positive={only_positive}
						required={required}
						show_error_on_exit={show_error_on_exit}
					/>
				);

			case "radio":
				return (
					<InputRadio
						id={id}
						label={label}
						name={name}
						radio_list={options}
						size={size}
						sx={sx}
						disabled={disabled}
						required={required}
						on_change={on_change}
					/>
				);

			default:
				return (
					<Input
						id={id}
						auto_focus={auto_focus}
						disabled={disabled}
						name={name}
						label={labelT}
						size={size}
						sx={sx}
						type={password ? "password" : "text"}
						on_change={on_change}
						placeholder={placeholder}
						full_width={full_width}
						auto_complete={auto_complete}
						start_adornment={start_adornment}
						end_adornment={end_adornment}
						helper={helper}
						required={required}
						show_error_on_exit={show_error_on_exit}
					/>
				);
		}
	};

	return determInput();
}
